import { render, staticRenderFns } from "./OrganizationUsages.vue?vue&type=template&id=2cc7b52c"
import script from "./OrganizationUsages.vue?vue&type=script&lang=js"
export * from "./OrganizationUsages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports